<template lang="pug">
.wrapper
  .content
    select(v-model="number")
      option 1
      option 2
      option 3
      option 4
      option 5
      option 6
      option 7
      option 8
    .player(v-for="player in screen")
      .grid
        label Name:
        input(type="text" v-model="player.name")
        label Character:
        character-picker(v-model="player.character")
  .buttonwrapper
    button(type="button" @click="OpenTournament" class="button") Start Tournament
</template>
<script>
import CharacterPicker from '@/components/CharacterPicker.vue';
import Event from '../event.js';
export default {
  name: 'PreGameScreen',
  components: {CharacterPicker},
  data () {
    return {
      players: [{name : undefined, score: 0, character: undefined}, {name : undefined, score: 0, character: undefined}, {name : undefined, score: 0, character: undefined}, {name : undefined, score: 0, character: undefined}, {name : undefined, score: 0, character: undefined}, {name : undefined, score: 0, character: undefined}, {name : undefined, score: 0, character: undefined}, {name : undefined, score: 0, character: undefined}],
      number: 0,
    }
  },
  methods: {
    OpenTournament() {
      Event.$emit('start tournament', this.players.filter(lambda => lambda.name != undefined));
    }
  },
  computed: {
    screen() {
      return this.players.slice(0, this.number);
    }
  },
}
</script>
<style lang="scss" scoped>
* {
  color: white;
}
.content {
  width: 80%;
  margin-left: 10%;
  margin-top: 5%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  .player {
    width: 40%;
    background: rgb(26, 26, 26);
    margin: 1%;
    margin-top: 3%;
    padding: 4%;
    border-radius: 20px;
    .grid {
      display: grid;
      grid-template-columns: 25% 75%;
      grid-auto-flow: row;
      label{
        display: flex;
        align-items: center;
        font-size: 25px;
        font-family: Tarrget Laser;
      }
    }
  }
  input{
    width: 100%;
    padding: 12px 20px;
    margin: 8px 8px;
    //display: inline-block;
    font-size: 20px;
    color: black;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
  }
  select {
    width: 100%;
    height: 50px;
    color: black;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    option{
      color: black;
    }
  }

  /* button {
    padding: 5%;
    margin: 5%;
  } */
}

  .buttonwrapper{
    text-align: center;
  }
  .button {
    background-color: #9F1002;
    border: none;
    color: white;
    padding: 15px 32px;
    text-align: center;
    text-decoration: none;
    //display: inline-block;
    font-size: 35px;
    border-radius: 5px;
    cursor: pointer;
    border: 2px solid #9F1002;
    margin: 2%;
    font-family: Tarrget Laser;
  }
  .button:hover {
    background-color: white;
    color: black;
  }

</style>
